/**
 * Header Logo Reveal on Scroll
 * - Logo is hidden at top of page
 * - Logo fades in when scrolling down
 * - Perfect for sticky headers that appear on scroll
 */

(function() {
  const headerLogo = document.querySelector('.header-logo--scroll-reveal');
  if (!headerLogo) return;

  let isScrolling = false;
  const scrollThreshold = 50; // Pixels to scroll before logo appears

  function updateLogoVisibility() {
    const scrollY = window.scrollY;
    
    if (scrollY < scrollThreshold) {
      // At top: logo is hidden
      headerLogo.style.opacity = '0';
      headerLogo.style.pointerEvents = 'none';
    } else {
      // Scrolled down: logo is visible
      headerLogo.style.opacity = '1';
      headerLogo.style.pointerEvents = 'auto';
    }
  }

  function handleScroll() {
    if (!isScrolling) {
      window.requestAnimationFrame(() => {
        updateLogoVisibility();
        isScrolling = false;
      });
      isScrolling = true;
    }
  }

  // Set initial state
  headerLogo.style.transition = 'opacity 0.3s ease';
  updateLogoVisibility();

  // Listen to scroll events
  window.addEventListener('scroll', handleScroll, { passive: true });
})();

